import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getScreenshotConfig',
  standalone: true
})
export class GetScreenshotConfigPipe implements PipeTransform {
  transform(diagram): any {
    if (diagram) {
      return {
        id: diagram.diagramId,
        state: diagram.state,
        size: '_600x400'
      };
    }
  }
}
